module.exports = __webpack_public_path__ + "media/flags/la-c558afec.svg";